import { useState, useCallback } from 'react';
import { assignDocumentToTask } from '../../services/TaskService';

export const useAssignDocumentToTask = () => {
  const [isAssigning, setIsAssigning] = useState(false);
  const [assignError, setAssignError] = useState(null);
  const [lastResult, setLastResult] = useState(null);

  const executeAssign = useCallback(
    async ({ documentConfigurationId, taskId, userId, fileUrl, createdAt }) => {
      setIsAssigning(true);
      setAssignError(null);

      try {
        const result = await assignDocumentToTask({
          documentConfigurationId,
          taskId,
          userId,
          fileUrl,
          createdAt,
        });

        setLastResult(result);

        return {
          ok: true,
          data: result,
        };
      } catch (error) {
        console.error('Error asignando documento a la tarea:', error);
        setAssignError(error);

        return {
          ok: false,
          error,
        };
      } finally {
        setIsAssigning(false);
      }
    },
    []
  );

  return {
    assignDocumentToTask: executeAssign,
    isAssigning,
    assignError,
    lastResult,
  };
};
